<template>
<div v-if="showOverlay" class="psb__overlay" @click="toggleShowOptions(false)"></div>
<!-- Sticky Bar PDP -->
<div id="sticky-bar" class="psb" :style="{ zIndex: showOptions ? '3' : '2' }" role="region">
  <div class="psb__desktop">
    <div class="psb__product-info">
      <ImageField :key="productImage" class="psb__product-image" :obj="{'url':productImage,'alt':'Alt Text','width':264,'height':264}" width-param="width" sizes="264px" fit="contain"/>
      <div class="psb__product-inner">
        <span class="psb__product-title"> {{ product.title }} </span>
        <ProductPrice
          :product="product"
          :selectedFirstOption="selectedFirstLevelOption"
        />
      </div>
    </div>
    <button @click="redirectToBuyBox" class="btn btn--secondary btn--medium psb__btn">Add to cart</button>
  </div>
  <div :class="['psb__wrapper',{'psb__wrapper--open': showOptions}]" v-focus-trap="showOverlay && showOptions">
    <div v-if="showOptions" class="psb__close" aria-label="close" @click="toggleShowOptions(false)" @keydown="handleKeydown" tabindex="0" role="button">
      <svg class="psb__close-icon" aria-hidden="true">
        <use href="#close"></use>
      </svg>
    </div>
    <div class="psb__outer">
      <div class="psb__left">
        <ImageField :key="productImage" class="psb__product-image" :obj="{'url':productImage,'alt':'Alt Text','width':264,'height':264}" width-param="width" sizes="264px" fit="contain"/>
        <div class="psb__product-inner">
          <span class="psb__product-title"> {{ product.title }} </span>
          <ProductPrice
            v-if="!showOptions"
            :product="product"
            :selectedFirstOption="selectedFirstLevelOption"
          />
        </div>
      </div>
      <div class="psb__right">
        <ProductPrice
          v-if="showOptions"
          class="psb--desktop"
          :product="product"
          :selectedFirstOption="selectedFirstLevelOption"
        />
        <ProductOptions
          v-if="showOptions"
          :key="product"
          :product="product"
          :selectedOptions="productForm"
          :isSecondTurn="false"
          @on-option-change="onOptionChange"
        />
        <ProductPrice
          v-if="showOptions"
          class="psb--mobile"
          :product="product"
          :selectedFirstOption="selectedFirstLevelOption"
        />
        <div data-sticky-cta v-if="productForm.selectedVariant || showOptions">
          <ProductATC
            :product="product"
            :productForm="productForm"
            :selectedVariant="productForm.selectedVariant"
            :selectedFirstOption="selectedFirstLevelOption"
            :isPDPstickyBar="true"
            @product-added="toggleShowOptions(false)"
          />
        </div>
        <button v-else data-sticky-cta @click="toggleShowOptions(true)" class="btn btn--secondary btn--medium psb__btn">SELECT OPTIONS</button>
      </div>
    </div>
  </div>
</div>
</template>

<script setup>
  import { computed, reactive, ref, watch } from 'vue';
  import { useStore } from "vuex";
  import ImageField from '../../global/image.vue';
  import ProductPrice from './product-price.vue';
  import ProductATC from './product-atc.vue';
  import ProductOptions from './product-options/index.vue';

  const props = defineProps({
    product: {
      type: Object,
      default: () => ({})
    }
  })

  const store = useStore();
  const product = reactive(props.product)
  const productForm = reactive(store.state.pdp.productForm)
  const showOptions = ref(false)
  const showOverlay = ref(false);

  const selectedFirstLevelOption = computed(() => {
    return store.state.pdp.firstLevelOptions?.[product.id];
  });

  const productImage = computed(() => {
    return store.state.pdp.firstLevelOptions?.[product.id]?.image || product.images[0].src || '';
  });

  const redirectToBuyBox = () => {
    const element = document.querySelector('#pm-buyBox')
    var elementPosition = element.getBoundingClientRect().top;
    var offsetPosition = window.innerWidth > 1024
      ? elementPosition + window.pageYOffset - 142
      : elementPosition + window.pageYOffset - 102;
    window.scrollTo({top: offsetPosition, behavior: "smooth"});
  }

  const toggleShowOptions = (value) => {
    showOptions.value = value;
    if(value){
      showOverlay.value = true;
      document.body.style.overflow = 'hidden'
    }else{
      showOverlay.value = false;
      document.body.style.overflow = 'auto'
    }
  }

  const handleKeydown = (event) => {
    const keysToClose = ['Enter', ' ', 'Spacebar']; // Spacebar is for older browsers
    if (keysToClose.includes(event.key)) {
      event.preventDefault(); // Prevent default behavior for Space
      toggleShowOptions(false);
    }
  };

  const onOptionChange = (key,value,index,length) => {
    updateProductForm(key,value)
    updateVariantValue();
  }

  const updateVariantValue = () => {
    const { options } = product;
    const variantValue = options.map(option => productForm[option.name]).join(' / ');
    updateSelectedVariant(variantValue);
  };

  const updateSelectedVariant = (value) => {
    const variant = product.variants.find(item => item.value === value);
    const selectedVariant = variant || null;
    updateProductForm('selectedVariant', selectedVariant);
    updateParams('update', productForm.selectedVariant);
  };

  const updateProductForm = (key,value) => {
    store.dispatch("updatePDPProductForm",{
      key: key,
      value: value
    });
  }

  const updateParams = (type, variant) => {
    const url = new URL(window.location.href);
    const params = new URLSearchParams(url.search);

    if (type === 'update' && variant) {
      params.set('variant', variant.id);
    } else if (type === 'delete') {
      params.delete('color');
    }

    url.search = params.toString();
    window.history.replaceState({ url: url.toString() }, null, url.toString());
  };

</script>